import React from "react";
import PropTypes from "prop-types";

// Components
import { PreviewCardSlim } from "components/PreviewCardSlim/PreviewCardSlim";

// Hooks
import { useDashboardAdsPreviewCard } from "./hooks/useDashboardAdsPreviewCard";

// Utils
import { handleKeyDown } from "utils/eventUtils";

export const DashboardAdsPreviewCard = ({
    isLoading = false,
    message,
    onOpenClaimLetterModal,
}) => {
    /**
     * Custom Hooks
     */

    const {
        brandMarkUrl,
        buttonStyle,
        cardStyle,
        elements,
        handleClick,
        isSponsored,
        primaryButton,
    } = useDashboardAdsPreviewCard({ message, onOpenClaimLetterModal });

    /**
     * Render
     */

    return (
        <PreviewCardSlim
            isLoading={isLoading}
            elements={elements}
            cardStyle={cardStyle}
            buttonStyle={buttonStyle}
            primaryButton={primaryButton}
            brandMarkUrl={brandMarkUrl}
            isSponsored={isSponsored}
            onClick={handleClick}
            onKeyDown={(e) => handleKeyDown(e, handleClick)}
        />
    );
};

DashboardAdsPreviewCard.propTypes = {
    isLoading: PropTypes.bool,
    message: PropTypes.object,
    onOpenClaimLetterModal: PropTypes.func,
};
